import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog, RoutalPalette } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';

import { useCancelSubscription } from '../hooks/backoffice/subscriptions/useCancelSubscription';
import Button from '../react-components/Button';
import Text from '../react-components/Text';

interface CancelSubscriptionDialogProps {
  userId: string;
  onClose: (hasCanceled?: boolean) => void;
}

export const CancelSubscriptionDialog = ({ userId, onClose }: CancelSubscriptionDialogProps) => {
  const { run: cancelSubscription, isLoading, success: cancelSuccess } = useCancelSubscription();

  useEffect(() => {
    if (cancelSuccess) {
      onClose(true);
    }
  }, [cancelSuccess, onClose]);

  return (
    <RoutalDialog
      open
      onCloseDialog={() => onClose()}
      titleContent={<Text variant="h6" intlId="cancel_subscription_dialog.title" />}
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button variant="flat" intlId="cancel" onClick={() => onClose()} />
          <HSpacer small />
          <Button
            disabled={isLoading}
            style={{
              backgroundColor: isLoading ? `rgba(0, 0, 0, 0.12)` : RoutalPalette.danger,
            }}
            onClick={async () => {
              cancelSubscription({ userId });
            }}
            intlId="cancel_subscription_dialog.title"
          />
        </Grid>
      }
    >
      <Grid container direction="column">
        <Grid item>
          <Text intlId="cancel_subscription_dialog.info" />
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
